export enum ClassLayout {
  Table = 'table',
  Calendar = 'calendar',
}
